import React from "react";
import { observer } from 'mobx-react';
import { withRouter } from 'helpers/ModuleHelper';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import * as ConfigTypes from 'config/ConfigTypes';

import "./Footer.scss";


const Footer = observer(

    class Footer extends React.Component {

        showImgBox = (item) => {
            return (
                <div className="footer-left-img-box">
                    <div className="footer-left-img-txt">
                        {this.props.intl.formatMessage({ id: 'footer.img.txt' })}
                    </div>
                    <div className="footer-left-img-div">
                        <img className="footer-left-img" src={item.url} alt="BKM-Logo" />
                    </div>
                </div>)
        }

        showListItem = ({ item, idx }) => {
            return (
                <div className="footer-left-item" key={`footer_items_${idx}`}>
                    <Link to={item.link}>
                        {item.isImg ? this.showImgBox(item)
                            : this.props.intl.formatMessage({ id: item.intl })}
                    </Link>
                </div>)
        }

        render() {
            return (
                <div className="appfooter" >
                    <div className="footer-container">
                        <div className="footer-left">
                            <div className="footer-left-items">
                                {ConfigTypes.FOOTER_ITEMS
                                    .map((item, idx) => this.showListItem({ item, idx }))}
                            </div>
                        </div>
                        <div className="footer-right">
                            {this.props.intl.formatMessage(
                                { id: "footer.copyright" },
                                { year: new Date().getFullYear() }
                            )}
                        </div>
                    </div>
                </div>
            )
        }
    })


export default withRouter(injectIntl(Footer));